import BaseCalendarIteractiveController from "./base_calendar_iteractive_controller";

export default class extends BaseCalendarIteractiveController {
  static targets = [
    'agenda',
    'form',
    'inputDate'
  ];

  async connect() {
    this.element[this.identifier] = this;

    this.initializeBase();
    this.selectLocation = this.element.querySelector('.location');
    [...this.element.querySelectorAll('.selected-schedule')].forEach(($el) => !!this.selectLocation && ($el.schedule.locationId = this.selectLocation.value));

    let turboFrame = this.element.closest('turbo-frame');
    !!turboFrame && await turboFrame.loaded;

    $(this.element.querySelectorAll('.filters .select2')).select2({
      placeholder: { id: 0, text: 'Todos' },
      multiple: false,
      allowClear: true,
      escapeMarkup: (markup) => markup,
      dropdownParent: this.element.closest('.modal')
    });
  }

  getObjSelectedSchedules() {
    return this.querySelectedSchedules()[1];
  }

  getSelectedSchedules() {
    return this.querySelectedSchedules()[0];
  }

  querySelectedSchedules() {
    let attributes = [...this.element.querySelectorAll('.card.selected-schedule, .card.selected-batch-schedule')].map(($el) => {
      return [...$el.querySelectorAll('.object-values')];
    }).flat(), object = {};

    attributes.map((node) => object[node.getAttribute('name').match(/\[(.*)?\]/gi)[0].replaceAll(/[\[\]]/gi, '')] = node.value);
    return [attributes, object];
  }

  submitForm() {
    let selectedSchedules = [];
    [...this.element.querySelectorAll('.selected-schedule')].map(($el) => selectedSchedules.push(Object.assign($el.schedule, { locationId: this.selectLocation.value })));
    this.formTarget.insertAdjacentHTML('afterBegin', `<input type="hidden" name="selected_schedules" value='${JSON.stringify(selectedSchedules)}' />`);
    super.submitForm();
  }
}